import apiFetch from '../apiFetch'

export default function (token, body) {
  return apiFetch({ endPoint: 'Repairshop/Users', method: 'POST', body: body, token: token })
}
